import { useContext } from 'react';

import OnboardingLayoutContext from './OnboardingContext';

const useOnboardingLayout = () => useContext(OnboardingLayoutContext);

export default useOnboardingLayout;
